export default __webpack_public_path__ + "static/media/video_image.84898577.jpg";